<template>
  <v-tabs
    :value="activeTab"
    show-arrows
    fixed-tabs
    color="transparent"
    slider-color="white"
    @change="changed"
  >
    <v-tab v-for="(tab, index) in tabs" :key="'bc_'+index">{{ tab.name }}</v-tab>
  </v-tabs>
</template>

<script>
// @vuese
// Taby do filtrowania zawartości
// @group Helpers
export default {
  props: {
    // indeks aktywnej zakładki
    active: { type: Object },
    // lista tab-ów, {name:'lorem'}
    tabs: { type: Array },
    toData: { type: Object },
    toParam: { type: String }
  },
  computed: {
    activeTab() {
      if (this.active && this.tabs) {
        return this.tabs.findIndex(tab => tab.id === this.active.id);
      }
    }
  },
  methods: {
    /**
     * @vuese
     * Informuje o zmianie indeksu aktywnej zakładki
     * @index Indeks do przekazania
     */
    changed(index) {
      this.$emit('change', this.tabs[index]);
    }
  }
};
</script>